// @flow
import React from 'react';
import { CLUSTER_LINKING_WORKLOADS_INPUTS_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { TextField } from '@src/formik-utils/FormFields';
import { CLUSTER_LINKING_WORKLOAD_DETAILS_CONFIG_MAP } from '@streaming-projects/workloads/cluster-linking-workloads/config';

export const SPClusterLinkingWorkloadNameContainer = ({
  disabled = false,
  fluid = null,
  disableOnFormErrors = null,
}) => {
  const { backendFieldName, displayName } = CLUSTER_LINKING_WORKLOAD_DETAILS_CONFIG_MAP.get(
    CLUSTER_LINKING_WORKLOADS_INPUTS_FIELDNAMES.WORKLOAD_NAME
  );
  return (
    <TextField
      disableOnFormErrors={disableOnFormErrors}
      disabled={disabled}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      fluid={fluid}
    />
  );
};
